import { ErrorMessage, Field, Form, Formik } from 'formik';
import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../store/Slices/AuthSlice';
import '../styles/Auth.css';
import { resetSchema } from '../utils/Schema';
import { passwordIcon } from '../utils/svgs';
import { errorNotify, successNotify } from '../utils/toast';

const ResetPassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const { loading, error } = useSelector((state) => state.auth);

    const [showPassword, setShowPassword] = useState(false);

    const handleResetPassword = async (values, { setSubmitting }) => {
        try {
            const resultAction = await dispatch(resetPassword({
                password: values.password,
                confirm_password: values.confirm_password,
                token: token
            }));

            if (resetPassword.fulfilled.match(resultAction)) {
                if (resultAction.payload?.data?.user_details) {
                    const userDetails = resultAction.payload.data.user_details;
                    localStorage.setItem('fms-maintenance-details', JSON.stringify(userDetails));
                }
                
                successNotify('Password reset successful');
                navigate('/');
            }
        } catch (error) {
            errorNotify(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className='main_auth_screen'>
            <Container fluid>
                <Row>
                    <Col lg={7} className='auth_left'>
                        <div>
                            <h2>Fleet Management System</h2>
                            <h6>Optimize Your Fleet. Reduce Costs. Drive Business Growth.</h6>
                        </div>
                    </Col>
                    <Col lg={5} className='auth_col'>
                        <div className='auth_form'>
                            <div>
                                <h1>Reset Password</h1>
                                <p>Reset your password</p>

                                <div className='auth_inputs'>
                                    <Formik
                                        initialValues={{
                                            password: '',
                                            confirm_password: ''
                                        }}
                                        validationSchema={resetSchema}
                                        onSubmit={handleResetPassword}
                                    >
                                        {({ isSubmitting }) => (
                                            <Form>
                                                <div className='mb-3'>
                                                    <div className="form-group password-field">
                                                        {passwordIcon}
                                                        <div style={{ position: 'relative', width: '100%' }}>
                                                            <Field
                                                                type={showPassword ? 'text' : 'password'}
                                                                name='password'
                                                                placeholder='Enter New Password'
                                                                className="form-control"
                                                            />
                                                            <span
                                                                className="password-toggle-icon"
                                                                onClick={() => setShowPassword(!showPassword)}
                                                            >
                                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <ErrorMessage name="password" component="div" className="error-message" />
                                                </div>

                                                <div className='mb-3'>
                                                    <div className="form-group password-field">
                                                        {passwordIcon}
                                                        <div style={{ position: 'relative', width: '100%' }}>
                                                            <Field
                                                                type={showPassword ? 'text' : 'password'}
                                                                name='confirm_password'
                                                                placeholder='Enter Confirm Password'
                                                                className="form-control"
                                                            />
                                                            <span
                                                                className="password-toggle-icon"
                                                                onClick={() => setShowPassword(!showPassword)}
                                                            >
                                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <ErrorMessage name="confirm_password" component="div" className="error-message" />
                                                </div>

                                                {error && (
                                                    <div className="error-message" style={{ color: 'red', marginBottom: '10px' }}>
                                                        {error}
                                                    </div>
                                                )}

                                                <button
                                                    type='submit'
                                                    disabled={isSubmitting || loading}
                                                >
                                                    {loading || isSubmitting ? 'Submitting...' : 'Submit'}
                                                </button>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default ResetPassword